import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDarkMode } from '@leafygreen-ui/leafygreen-provider';
const importBrandIcon = async (filename, isDarkMode) => await import(`./images/${isDarkMode ? 'dark' : 'light'}/${filename}`);
/**
 * This generalized component allows for images that get swapped automatically from light to
 * dark mode. Ideally, this component lives in @packages/themed-images, however since we publish the
 * @packages/brand-icons directory for App Services, we keep it here to prevent brand-icons
 * from needing to reach out.
 */
const ThemedImage = ({ Component, filename, isDarkMode, createImgSrc = importBrandIcon, ...props }) => {
    const [imgSrc, setImgSrc] = useState();
    const { darkMode } = useDarkMode(isDarkMode);
    useEffect(() => {
        let unmounted = false;
        const fetchImage = async () => {
            const importImg = await createImgSrc(filename, darkMode);
            if (!unmounted)
                setImgSrc(importImg.default);
        };
        fetchImage();
        return () => {
            unmounted = true;
        };
    }, [createImgSrc, darkMode, filename]);
    return Component ? _jsx(Component, { ...props, src: imgSrc }) : _jsx("img", { ...props, src: imgSrc });
};
export default ThemedImage;
